import React, { useRef, useState, useEffect, useLayoutEffect } from 'react'
import { useParams } from 'react-router-dom'
import axios from 'axios'
import { NavigationAOComponent } from './NavigationAO'

export const DisplayHtmlComponent = ({ html }) => {
    const iframe = useRef();

    useLayoutEffect(() => {
        if (iframe && iframe.current) {
            try {
                iframe.current.contentWindow.document.body.innerHTML = html
            }
            catch (e) {
                console.log("impossible d'afficher le html")
            }
        }
    }, [html]);

    return <iframe ref={iframe} style={{ width: '100%', height: '700px' }} />
}


export const AOHtmlComponent = () => {
    const { aoId } = useParams();
    const [aoHtml, setAoHtml] = useState();

    useEffect(() => {
        axios.get('/api/aoget/html?id=' + aoId)
            .then(response => {
                if (response.data) {
                    setAoHtml(response.data)
                }
            });
    }, [aoId])

    let result = <>l'ao n'existe pas</>

    if (aoHtml) {
        result = 
            <div><NavigationAOComponent aoId={aoId} pageType={"aohtml"} ></NavigationAOComponent> <DisplayHtmlComponent html={aoHtml} />
                </div>
    }

    return result;
}
